var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('header-component',{attrs:{"type":"nubi-school"}}),_c('div',{staticClass:"education-page-container"},[_c('e-first-component'),_c('e-second-component'),_c('e-third-component')],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }